/** @mixin buttonResetMixin */
/**
 * Removes browser default styling for the button element.
 *
 * @example
 * import { buttonResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.button`
 *     ${buttonResetMixin}
 * `;
 *
 * <Component>My button</Component>
 *
 * @method
 * @return {CSSObject}
 */
export var buttonResetMixin = function buttonResetMixin() {
  return "\n    border: 0;\n    background: none;\n    padding: 0;\n    text-align: initial;\n    -webkit-appearance: none; /* Override Safari appearance */\n\n    &:not(:disabled) {\n        cursor: pointer;\n    }\n";
};